import React from 'react';
import styles from './AjaxSpinner.module.sass';

const ajaxSpinner = (props) => {
    let spinner = null;
    if (props.loading) {
        spinner = (
          <React.Fragment>
              <div data-html2canvas-ignore className={styles.Backdrop}/>
              <div data-html2canvas-ignore className={styles.spinner}>
                  <div className={styles.bouncer + ' ' + styles.bounce1}/>
                  <div className={styles.bouncer + ' ' + styles.bounce2}/>
                  <div className={styles.bouncer}/>
              </div>
          </React.Fragment>
        );
    }
    return spinner;
};

export default ajaxSpinner;